export default "__VITE_ASSET__BoybZt_u__"